import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30d5e01e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "common-layout"
}

import store from '../store'
import { onMounted, ref } from 'vue'
import { appInit, apiFetchData, MenuTree, getMaxId, isEmptyString, isEmptyArray, fillNullId, getOpenMenuIds, setCookie, getLanguage } from '../utils'
import { apiMenuPath, cookieMaxAge } from '../config'

import HeaderMenuRender from '../components/HeaderMenuRender.vue'
import HomePageLeftMenuRender from '../components/HomePageLeftMenuRender.vue'
import HomePageTabs from './HomePageTabs.vue'
import WarningDlg from './WarningDlg.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const refShow = ref(false)
onMounted(async () => {
  try {
    appInit()

    const language = getLanguage()
    setCookie('Language', language, cookieMaxAge * 10000)

    const data = await apiFetchData(apiMenuPath)
    refShow.value = true
    let curId = getMaxId(data)
    function restructMenu (data: MenuTree[], depth: number) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].label === '$UserRightMenu$') {
          data[i].label = store.state.userName
        }
        if (isEmptyString(data[i].tag)) {
          if (depth === 0) {
            // 顶层菜单
            data[i].tag = 'el-menu-item'
          } else if (depth === 1) {
            // 左侧一级菜单
            data[i].tag = 'el-icon-menu-item'
          } else {
            // eslint-disable-next-line
            if (!isEmptyArray(data[i].children)) {
              // 有子菜单
              data[i].tag = 'el-sub-menu'
            } else {
              data[i].tag = 'el-menu-item'
            }
          }
        }
        if (isEmptyString(data[i].id)) {
          data[i].id = String(curId)
          curId = curId + 1
        }
        if (!isEmptyArray(data[i].children)) {
          restructMenu(data[i].children as MenuTree[], depth + 1)
        }
      }
    }
    restructMenu(data, 0)
    console.log('onMounted data=', data)
    store.state.meunTree = data
    // eslint-disable-next-line
    store.state.leftMenu = store.state.meunTree[0].children!
    store.state.leftMenuOpenedIds = getOpenMenuIds(store.state.meunTree)
    store.state.homeMenuIndex = data[0].id
  } catch (error) {
    console.error(error)
  }

  try {
    const data = await apiFetchData(store.state.editableTabs[0].url)
    console.log('data=', data)
    fillNullId(data)
    const resut: {[key: string]: string} = {}
    store.state.modelValues[store.state.editableTabs[0].name] = resut
    store.state.editableTabs[0].data = data
  } catch (error) {
    console.error(error)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (refShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, null, {
              default: _withCtx(() => [
                _createVNode(HeaderMenuRender)
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                (!_unref(isEmptyArray)(_unref(store).state.leftMenu))
                  ? (_openBlock(), _createBlock(HomePageLeftMenuRender, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_main, null, {
                      default: _withCtx(() => [
                        _createVNode(HomePageTabs)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(WarningDlg)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})